import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import ImagesGrid from "segments/desktop/core-components/images-grid/images-grid";
import FullParagraphDefaultProps from "segments/desktop/core-components/full-paragraph/default-props";
import { positionTypes } from "segments/desktop/core-components/images-grid/images-grid-service";
import { MD } from "constants/sizes";
import { StyledIconWithParagraphGridComponent } from "./icon-with-paragraph-grid-component.scss";
class IconWithParagraphGridComponent extends PureComponent {
    render() {
        const { images, imagePosition, imagesGap, textAlign, titleSize, textSize, iconWidth, iconHeight, disableFixedWidth } = this.props;
        return /*#__PURE__*/ _jsx(StyledIconWithParagraphGridComponent, {
            className: "icon-with-paragraph-grid-component",
            children: /*#__PURE__*/ _jsx(ImagesGrid, {
                disableFixedWidth: disableFixedWidth,
                images: images,
                imagesGap: imagesGap,
                isWithParagraph: true,
                imagePosition: imagePosition,
                textAlign: textAlign,
                titleSize: titleSize,
                textSize: textSize,
                imageStyle: {
                    width: iconWidth,
                    height: iconHeight
                },
                isIcon: true
            })
        });
    }
}
export { IconWithParagraphGridComponent as default };
IconWithParagraphGridComponent.defaultProps = {
    images: [
        {
            src: "/static/img/heart_small.png",
            fullParagraph: FullParagraphDefaultProps
        },
        {
            src: "/static/img/heart_small.png",
            fullParagraph: FullParagraphDefaultProps
        },
        {
            src: "/static/img/heart_small.png",
            fullParagraph: FullParagraphDefaultProps
        }
    ],
    paddingTop: "56px",
    paddingBottom: "56px",
    imagePosition: positionTypes.CENTER_LEFT,
    textAlign: "left",
    titleSize: MD,
    textSize: MD,
    iconWidth: "50px",
    iconHeight: "50px"
};
